module.exports = __webpack_public_path__ + "images/FUSA_icons/053-delivery-truck-2.1056b282057e3bee61dba458f0dfab54.svg";